
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';
import { DeepAnalysisResult } from '@/types/analysisTypes';

interface AnalysisWarningsProps {
  pageAnalysisResult: DeepAnalysisResult;
}

export const AnalysisWarnings: React.FC<AnalysisWarningsProps> = ({ pageAnalysisResult }) => {
  const hasAnalysisError = pageAnalysisResult.error !== undefined;
  const hasZeroScores = pageAnalysisResult.overall_score === 0 && 
    Object.values(pageAnalysisResult.category_scores).every(score => score === 0);

  if (!hasAnalysisError && !hasZeroScores) {
    return null;
  }

  return (
    <>
      {hasAnalysisError && (
        <Alert className="mb-4 border-amber-200 bg-amber-50 dark:border-amber-800 dark:bg-amber-950/20 text-amber-800 dark:text-amber-300">
          <AlertCircle className="h-4 w-4 text-amber-500" />
          <AlertTitle className="text-amber-700 dark:text-amber-400">Analysis Error</AlertTitle>
          <AlertDescription className="text-amber-600 dark:text-amber-500">
            {pageAnalysisResult.error}
          </AlertDescription>
        </Alert>
      )}
      
      {!hasAnalysisError && hasZeroScores && (
        <Alert className="mb-4 border-amber-200 bg-amber-50 dark:border-amber-800 dark:bg-amber-950/20 text-amber-800 dark:text-amber-300">
          <AlertCircle className="h-4 w-4 text-amber-500" />
          <AlertTitle className="text-amber-700 dark:text-amber-400">Analysis Warning</AlertTitle>
          <AlertDescription className="text-amber-600 dark:text-amber-500">
            All scores are zero, which may indicate a problem with the analysis. Please check the Full Report tab to see the raw response.
          </AlertDescription>
        </Alert>
      )}
    </>
  );
};
